import { GraftCodePrimitiveType } from '@graftcode/protocol'

import { getCanonicalFromRawName } from '@/core/config/typeTranslations'
import { classifyTypeUsage } from '@/core/utils/mappers/formatTypeUsage/classifyTypeUsage'
import type { NodeLike } from '@/core/utils/mappers/formatTypeUsage/types'

function isPermissiveCanonical(raw: string | undefined): boolean {
  if (!raw) return false
  const canonical = getCanonicalFromRawName(raw.trim())
  return canonical === 'any' || canonical === 'object'
}

export function isGraftableAnyOrObjectType(typeUsage: NodeLike): boolean {
  const legacyRaw = typeUsage.payload[0]
  if (typeof legacyRaw === 'string' && isPermissiveCanonical(legacyRaw)) {
    return true
  }

  const shape = classifyTypeUsage(typeUsage)
  if (shape.kind !== 'primitive') return false

  if (shape.primitiveType === GraftCodePrimitiveType.UNKNOWN) {
    return true
  }

  return shape.primitiveType === GraftCodePrimitiveType.GRAFT_MODEL && isPermissiveCanonical(shape.typeFqn)
}
